'use client';

import { ActionResponse } from '@pickleballinc/lib/server/next/actions/types';
import { useMutation } from '@tanstack/react-query';

import { useRecaptchaEnterprise } from '@/hooks/useRecaptchaEnterprise';
import { NewsletterError } from '@/types/homepage.types';
import { CaptchaAction } from '@/utils/helpers/captcha-actions';

export interface SubscribeParams {
  email: string;
  captchaToken: string;
  captchaAction: CaptchaAction;
}

export const useNewsletterSubscribe = (
  action: (params: SubscribeParams) => Promise<ActionResponse<unknown>>,
  captchaAction: CaptchaAction
) => {
  const { executeRecaptcha } = useRecaptchaEnterprise();

  return useMutation<boolean, NewsletterError, string>({
    mutationFn: async (email: string) => {
      const captchaToken = await executeRecaptcha(captchaAction);

      if (!captchaToken) {
        throw { statusCode: 403, error: 'Captcha verification failed' };
      }

      const res = await action({ email, captchaToken, captchaAction });

      if (res?.statusCode !== 202) {
        throw {
          statusCode: res?.statusCode,
          error: res?.error,
        };
      }

      return true;
    },
  });
};
